import { t } from "i18next";
import { PropsWithChildren } from "react";

import { fontWeight } from "#app/theme/v1/fontWeights";
import { Flex } from "#shared/view/components/Flex";
import { Image } from "#shared/view/components/Image";
import { Space } from "#shared/view/components/Space";
import { Stack } from "#shared/view/components/Stack";
import { Text } from "#shared/view/components/Text";

export const SimilarPartsErrorCheck = ({
  similarParts,
  children,
}: {
  similarParts: Array<unknown> | null;
} & PropsWithChildren) => {
  if (!similarParts) {
    return (
      <Flex direction={"column"} align={"center"} justify={"center"} w={"100%"}>
        <Image src="/images/search.png" w={150} h={150} />
        <Space h="md" />
        <Text w="50%" fw={fontWeight.bold} ta="center">
          Commencez par charger une pièce pour voir des pièces similaires.
        </Text>
      </Flex>
    );
  }

  if (similarParts.length === 0) {
    return (
      <Stack align={"center"} justify={"center"}>
        <Image src="/images/search.png" w={150} h={150} />
        <Space h="md" />
        <Text w="50%" fw={fontWeight.bold} ta="center">
          {t("similarPart.no_similar_parts")}
        </Text>
      </Stack>
    );
  }

  return children;
};
